import * as React from 'react';
import { translation } from 'easit--localization';
import { CashOutList } from './cashOutList';
import { ICashOutListStore } from 'eTip--common';
import { CashOutItem } from './cashOutItem';
import { observer } from 'mobx-react';
import { NoResultsEmptyList, NoResultsLoginNeeded } from '../noResults/noResults';

export interface ICashOutTicketsProps {
    cashoutStore: ICashOutListStore;
    goToDetail: (ticketId: number) => void;
    reloadOnError: () => void;
}

export const CashOutTickets = observer((props: ICashOutTicketsProps) => {
    const t = translation();
    const testRoleMainPart = "cashout-list";

    return (<div className="h-100" data-test-role={testRoleMainPart}>
        {
            props.cashoutStore.isAllowed ?
                (
                    props.cashoutStore.isLoading
                        ? <div className="text-center p-3"><span className="fas fa-spinner fa-spin"></span> {t.general_Loading}</div>
                        : <div>
                            {
                                props.cashoutStore.errorMessage ?
                                    <div className="p-2 text-center">
                                        {props.cashoutStore.errorMessage}<br />
                                        <button className="btn btn-primary mr-1" onClick={() => { props.reloadOnError() }}>{translation().cashoutList_LoadAgain}</button>
                                    </div>
                                    :
                                    (props.cashoutStore.bets.length > 0 ?
                                        <CashOutList items={<CashOutItem cashOutList={props.cashoutStore} onGoToDetail={props.goToDetail} />}
                                        />
                                        : <NoResultsEmptyList className={__IsMTSTipos__ ? "p-2" : "p-3"} message={translation().cashoutList_NoTickets} testRoleMainPart={testRoleMainPart} />
                                    )
                            }
                        </div>
                )
                :
                <NoResultsLoginNeeded className={__IsMTSTipos__ ? "p-2" : "p-3"} message={translation().cashoutList_Login} testRoleMainPart={testRoleMainPart} />
        }
    </div>)
});
